import { supabase } from '../lib/supabase'

export const newsService = {
  // Get all news
  async getNews(filters = {}) {
    try {
      let query = supabase
        .from('news')
        .select(`
          id,
          title,
          content,
          category,
          author_id,
          image_url,
          created_at,
          users!author_id(
            id,
            full_name,
            profile_image_url
          ),
          news_likes(
            user_id
          ),
          news_comments(
            id
          )
        `)
        .order('created_at', { ascending: false })

      // Apply filters
      if (filters.category) {
        query = query.eq('category', filters.category)
      }

      if (filters.limit) {
        query = query.limit(filters.limit)
      }

      const { data, error } = await query
      
      if (error) throw error
      return { data, error: null }
    } catch (error) {
      return { data: null, error: error.message }
    }
  },

  // Get news by ID
  async getNewsById(id) {
    try {
      const { data, error } = await supabase
        .from('news')
        .select(`
          *,
          users!author_id(
            id,
            full_name,
            profile_image_url
          ),
          news_likes(
            user_id
          ),
          news_comments(
            id,
            content,
            created_at,
            users!user_id(
              id,
              full_name,
              profile_image_url
            )
          )
        `)
        .eq('id', id)
        .single()
      
      if (error) throw error
      return { data, error: null }
    } catch (error) {
      return { data: null, error: error.message }
    }
  },

  // Create news (admin only)
  async createNews(newsData) {
    try {
      const { data, error } = await supabase
        .from('news')
        .insert(newsData)
        .select()
        .single()
      
      if (error) throw error
      return { data, error: null }
    } catch (error) {
      return { data: null, error: error.message }
    }
  },

  // Update news (admin only)
  async updateNews(id, updates) {
    try {
      const { data, error } = await supabase
        .from('news')
        .update(updates)
        .eq('id', id)
        .select()
        .single()
      
      if (error) throw error
      return { data, error: null }
    } catch (error) {
      return { data: null, error: error.message }
    }
  },

  // Delete news (admin only)
  async deleteNews(id) {
    try {
      const { error } = await supabase
        .from('news')
        .delete()
        .eq('id', id)
      
      if (error) throw error
      return { error: null }
    } catch (error) {
      return { error: error.message }
    }
  },

  // Like/unlike news
  async toggleNewsLike(userId, newsId) {
    try {
      
      // Check if already liked
      const { data: existingLike, error: checkError } = await supabase
        .from('news_likes')
        .select('*')
        .eq('user_id', userId)
        .eq('news_id', newsId)
        .maybeSingle()


      if (checkError) {
        throw checkError
      }

      if (existingLike) {
        // Remove like
        const { error } = await supabase
          .from('news_likes')
          .delete()
          .eq('user_id', userId)
          .eq('news_id', newsId)
        
        if (error) throw error
        return { liked: false, error: null }
      } else {
        // Add like
        const { error } = await supabase
          .from('news_likes')
          .insert({
            user_id: userId,
            news_id: newsId
          })
        
        if (error) throw error
        return { liked: true, error: null }
      }
    } catch (error) {
      return { liked: false, error: error.message }
    }
  },

  // Add comment to news
  async addNewsComment(userId, newsId, content) {
    try {
      const { data, error } = await supabase
        .from('news_comments')
        .insert({
          user_id: userId,
          news_id: newsId,
          content
        })
        .select(`
          *,
          users!user_id(
            id,
            full_name,
            profile_image_url
          )
        `)
        .single()
      
      if (error) throw error
      return { data, error: null }
    } catch (error) {
      return { data: null, error: error.message }
    }
  },

  // Get comments for news
  async getNewsComments(newsId) {
    try {
      const { data, error } = await supabase
        .from('news_comments')
        .select(`
          *,
          users!user_id(
            id,
            full_name,
            profile_image_url
          )
        `)
        .eq('news_id', newsId)
        .order('created_at', { ascending: true })
      
      if (error) throw error
      return { data, error: null }
    } catch (error) {
      return { data: null, error: error.message }
    }
  }
}